import { useForm } from "react-hook-form";
import styles from "./codeForm.module.css";
import { Button } from "../../ui/button/Button";
import { useUserStore } from "../../../stores/useUserStore";
import { useMutation } from "@tanstack/react-query";
import { authApi } from "../../../api/authMutation/authApi";
import { useNavigate } from "react-router";
export function CodeForm() {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const { user, setCredentials } = useUserStore();
    const navigate = useNavigate();
    const { mutate, error } = useMutation({
        mutationFn: (loginData) => {
            return authApi.token(loginData);
        },
        onSuccess: (data) => {
            const username = user
            setCredentials({ token: data.data.token, username })
            navigate('/');
        },
    });


    function handleCodeFromEmail(data) {
        data.username = user;
        mutate(data);
    }

    return (
        <form className={styles.form} onSubmit={handleSubmit(handleCodeFromEmail)}>
            <div>
                <div className={styles.input_wrapper}>
                    <input
                        type="number"
                        placeholder="Введите код из письма"
                        className={`${styles.input} ${errors.confirmation_code && styles.errorInput}`}
                        {...register('confirmation_code', {
                            required: 'Это поле обязательно',
                            minLength: {
                                value: 6,
                                message: 'Код должен содержать 6 символов',
                            },
                            maxLength: {
                                value: 6,
                                message: 'Код должен содержать 6 символов',
                            },

                        })}
                    />
                    {(errors.confirmation_code || error) && (
                        <span className={styles.error}>
                            {errors.confirmation_code?.message || error?.message || "Непредвиденная ошибка"}
                        </span>
                    )}
                </div>
            </div>
            <Button type="submit" variant={'dark-blue'}>
                Зарегистрироваться
            </Button>
        </form>
    );
}
